module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Snare Accent-6859dcd897153306917401e121d1f400.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Snare Accent.mp3
// module id = 54
// module chunks = 0